import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation, signal, WritableSignal,
} from '@angular/core';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import {
  RecommendedPartnerOffer,
  ShelterPartner,
} from '../../shared-models/partners.model';
import { OfferExpirationTime, OffersService } from "../../services/offers.service";

@Component({
  selector: 'lib-edit-partner',
  templateUrl: './edit-partner.component.html',
  styleUrls: ['./edit-partner.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class EditPartnerComponent implements OnInit, OnChanges {
  @Input() partner!: ShelterPartner;
  @Input() recommended = false;
  @Input() categories: { key: string; value: string }[] = [];
  @Input() offers: RecommendedPartnerOffer[] = [];

  form!: FormGroup;
  offerOption = '';

  offerList: WritableSignal<string[]> = signal([]);
  expirationTimeList: WritableSignal<OfferExpirationTime[]> = signal([]);

  constructor(public offcanvasRef: NgbActiveOffcanvas,
              private offersService: OffersService) {}

  ngOnInit() {
    this.offerList.set(this.offersService.offers);
    this.expirationTimeList.set(this.offersService.expirationTime);

    this.buildForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['partner'] ||
      changes['recommended'] ||
      changes['offers'] ||
      changes['categories']
    ) {
      this.buildForm();
    }
  }

  private buildForm() {
    this.form = new FormGroup({
      category: new FormControl(this.partner.category, Validators.required),
      secondaryCategory: new FormControl(this.partner.secondaryCategory),
      recommended: new FormControl(this.recommended),
      offers: new FormArray(
        (this.offers || []).map(o =>
          new FormGroup({
            offer: new FormControl(o.offer, Validators.required),
            days:  new FormControl(o.days.toString(), Validators.required)
          })
        )
      ),
      newOffer: new FormControl(
        { value: '', disabled: true },
        Validators.required
      ),
      newDays: new FormControl('30', Validators.required),
    });
  }

  get offersFA(): FormArray {
    return this.form.get('offers') as FormArray;
  }

  onSelectOfferChange(evt: Event) {
    const val = (evt.target as HTMLSelectElement).value;
    this.offerOption = val;

    const newOfferCtrl = this.form.get('newOffer')!;

    if (val === 'other') {
      newOfferCtrl.reset();
      newOfferCtrl.enable();
      newOfferCtrl.setValidators(Validators.required);
    } else {
      newOfferCtrl.setValue(val);
      newOfferCtrl.clearValidators();
      newOfferCtrl.disable();
    }
    newOfferCtrl.updateValueAndValidity();
  }

  addOffer() {
    const newOfferCtrl = this.form.get('newOffer')!;
    const val = newOfferCtrl.value;
    if (!val) return;
    if (this.offersFA.controls.some(c => c.value.offer === val)) return;

    this.offersFA.push(new FormGroup({
      offer: new FormControl(val, Validators.required),
      days:  new FormControl(this.form.value.newDays, Validators.required)
    }));

    this.offerOption = '';
    newOfferCtrl.reset();
    this.form.get('newDays')!.reset('30');
  }

  removeOffer(i: number) {
    this.offersFA.removeAt(i);
  }

  getExpirationLabel(days: string): string {
    const e = this.expirationTimeList().find((x) => x.value === days);
    return e ? e.label : '';
  }

  save() {

    const updatedPartner: ShelterPartner = {
      ...this.partner,
      category: this.form.value.category,
      secondaryCategory: this.form.value.secondaryCategory,
    };

    const updatedOffers: RecommendedPartnerOffer[] = this.offersFA.value.map(
      (o: any) => ({
        offer: o.offer,
        days: +o.days,
      })
    );

    this.offcanvasRef.close({
      action: 'save',
      partner: updatedPartner,
      recommended: this.form.value.recommended,
      offers: updatedOffers,
    });
  }
}
